export const CLIENT_EMAIL = 'bonanzaagroindustries@gmail.com'
export const CLIENT_ID = 'pT2pFKYQicZves7D8M6l'
export const CLIENT_UID = '17AW9m6do8RNcLeJO6QlwYI4mTr1'
export const  OWNER_NAME = 'Bonanza Agro Industries'